import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import Modal from 'react-modal';

import {Button} from 'components/Button';

import {getContentStyles, getOverlayStyles, Title, Subtitle, WrapperButton} from './styles';
import messages from './messages';

class LogoutDialog extends Component {
  render() {
    const {
      isDesktop,
      intl: {formatMessage},
      isOpen,
      logout
    } = this.props;

    const styles = {
      overlay: getOverlayStyles(),
      content: getContentStyles({isDesktop})
    };

    return (
      <Modal style={styles} isOpen={isOpen} ariaHideApp={false}>
        <Title>{formatMessage(messages.title)}</Title>
        <Subtitle>{formatMessage(messages.subtitle)}</Subtitle>

        <WrapperButton>
          <Button onClick={logout}>{formatMessage(messages.signOut)}</Button>
        </WrapperButton>
      </Modal>
    );
  }
}

export default injectIntl(LogoutDialog);
